import TagManager from 'react-gtm-module'

export default function triggerGAEvent(dataLayer: {
    page: string, event: string, params?: {
        spaceTitle?: string,
    }
}) {
    if (typeof window !== 'undefined') {
        TagManager.dataLayer({
            dataLayer: dataLayer,
        })
    }
}